import { render, staticRenderFns } from "./IntroPage3.vue?vue&type=template&id=1ddda48c&"
import script from "./IntroPage3.vue?vue&type=script&lang=js&"
export * from "./IntroPage3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports